import React, { useRef } from "react";
import emailjs from "@emailjs/browser";

function CommentSection() {
  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm(
        "service_hodxf6f",
        "template_uwikezl",
        form.current,
        "jPbdCjinNF21SdGVk",
      )
      .then(
        (result) => {
          alert("E-mail sent successfully. Thank you for Contacting us!");
        },
        (error) => {
          alert("Unsuccessful, Please Try again!", error.text);
        },
      );
  };

  return (
    <div className="w-full">
      <div className="my-16 pb-3 container w-11/12 lg:w-1/2 mx-auto">
        <h1 className="text-2xl font-bold text-center mb-8 uppercase tracking-wider">
          Your Comments
        </h1>
        <form
          ref={form}
          onSubmit={sendEmail}
          method="post"
          className="w-full flex flex-col gap-6">
          <input
            required
            type="text"
            name="user_name"
            placeholder="Your Name"
            className="w-full border border-neutral-400 py-2 pl-5 rounded-xl text-sm focus:outline-none focus:border-sky-600 "
          />
          <input
            required
            type="email"
            name="user_email"
            placeholder="Your Email"
            className="w-full border border-neutral-400 py-2 pl-5 rounded-xl text-sm focus:outline-none focus:border-sky-600 "
          />
          <textarea
            required
            name="message"
            placeholder="Type Your Message..."
            className="w-full h-40 border border-neutral-400 py-2 pl-3 rounded-xl text-sm focus:outline-none focus:border-sky-600 "></textarea>
          <input
            type="submit"
            className="w-36 mx-auto mt-4 py-2 px-8 transition shadow-xl bg-sky-600 hover:bg-sky-500 focus:bg-sky-600 focus:scale-95 text-white rounded-xl cursor-pointer"
            value="Send"
          />
        </form>
      </div>
    </div>
  );
}

export default CommentSection;
